import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { AssetForceReturnApi, AssetReturnApi } from "../../../services/AssetService";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaUndoAlt } from "react-icons/fa";
const AssetForceReturnModal = ({ assetData, open, onClose, afterSubmit }) => {
  const { id,model_number,brand } = assetData || {};
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (open) {
      setReason("");
    }
  }, [open]);
  const handleConfirm = () => {
    setLoading(true);
    AssetForceReturnApi(id,{ reason: reason })
      .then((res) => {
        toast.success("Return Successfully");
        afterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-danger">
        <FaUndoAlt className="fs-4" />
        <span>Return Asset</span>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" className="mb-2">
          Are you sure you want to return this asset?
        </Typography>
        <div className="border rounded p-3 bg-light mb-2">
          <Typography variant="body2" className="mb-1">
            <strong>Model:</strong> {model_number || "-"}
          </Typography>
          <Typography variant="body2">
            <strong>Brand:</strong> {brand || "-"}
          </Typography>
        </div>
        <TextField
          autoFocus
          label="Reason for Return"
          multiline
          rows={2}
          fullWidth
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter reason for returning this asset..."
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
        >
          {loading && <Spinner animation="border" size="sm" />}
          Confirm Return
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetForceReturnModal;
